import { Button, Col, Form, FormInstance, Input, InputNumber, Modal, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import MoneyInput from "src/components/MoneyInput/MoneyInput";
import { SettingLoadingMethod } from "src/entity/settings/terminal-market";
import { generateErrorMessage } from "src/utils/error-message";
import { onKeyDownNumberWithFixedDecimal } from "src/utils/key-down-validate";
import { cleanNumberRemoveComma, cleanNumberStringInObject, formatNumber } from "src/utils/process-number";

const { Text } = Typography;

const LoadingMethodModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";
  isDuplicate: boolean;
  onDuplicateChange: (isDup: boolean) => void;
  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: SettingLoadingMethod) => void;
}) => {
  const { form, loading, open, mode, isDuplicate, onDuplicateChange, onCloseModal, onSave } = props;
  const precision = 2;
  const [errorDuplicate, setErrorDuplicate] = useState<string | null>(null);

  const handleSave = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const convertValues = cleanNumberStringInObject(values, ["sFactor"]);
      onSave(mode, convertValues as unknown as SettingLoadingMethod);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeForm = (changeValue: any) => {
    // Object.keys(changeValue).forEach((key) => {
    //   if (["sFactor"].includes(key)) {
    //     if (changeValue[key] && changeValue[key] > 100) {
    //       form.setFieldsValue({
    //         [key]: 100,
    //       });
    //     }
    //   }
    // });
    if (["loadingBy", "sFactor"].some((key) => changeValue[key])) {
      onDuplicateChange(false);
    }
  };

  useEffect(() => {
    const errorText = isDuplicate ? "Loading By and S Factory already exists in the system." : "";
    setErrorDuplicate(errorText);
    form.setFields(
      ["loadingBy", "sFactor"].map((field) => ({
        name: field,
        errors: isDuplicate ? [""] : [],
      })),
    );
  }, [isDuplicate]);

  return (
    <Modal
      centered
      maskClosable={false}
      open={open}
      onCancel={onCloseModal}
      width={700}
      title={<ModalTitle title="Loading Method" />}
      footer={
        <Row className="w-full border-t" justify={"end"}>
          <Button className="mt-4" key="submit" type="primary" loading={loading} onClick={handleSave}>
            Save
          </Button>
        </Row>
      }
    >
      {errorDuplicate && (
        <>
          <Row className="w-full" justify={"center"}>
            <Text type="danger">{errorDuplicate}</Text>
          </Row>
        </>
      )}
      <Form size="middle" layout="vertical" autoComplete="off" form={form} requiredMark={false} onValuesChange={onChangeForm}>
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={12} lg={12}>
            <Form.Item
              label={<FormLabel label={"Loading By"} required />}
              name="loadingBy"
              rules={[{ required: true, message: generateErrorMessage("Loading By") }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={12}>
            <Form.Item
              label={<FormLabel label={"S Factor"} required />}
              name="sFactor"
              rules={[{ required: true, message: generateErrorMessage("S Factor") }]}
            >
              <MoneyInput precision={2} formInstance={form} field="sFactor" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item label={<FormLabel label={"Remark"} />} name="remark">
              <Input.TextArea rows={3}></Input.TextArea>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default LoadingMethodModal;
